import { createReducer } from '@reduxjs/toolkit';
import {
  EDIT_PAR_AM_BOOKING,
  GET_PARKING_PAR_AM_BOOKINGS,
  GET_SELECTED_BOOKINGS,
  GET_BOOKINGS_LIST_V3,
  GET_BOOKINGS_CALENDAR_V3,
  GET_BOOKING_V3,
  GET_AMENITY_PAR_AM_BOOKINGS,
  GET_PAR_AM_BOOKING,
  ADD_PAR_AM_BOOKING,
  ADD_BOOKING_V3,
  EDIT_BOOKING_V3,
  EDITING_PAR_AM_BOOKING,
  GET_AVAILABLE_TIME,
  GET_AMENITY_AVAILABILITY_V2,
  CLEAR_AMENITY_AVAILABILITY_V2,
  GET_BOOKING_COST_BREAKDOWN,
  CLEAR_BOOKING_COST_BREAKDOWN,
  SET_PARAM_ERROR,
  CANCEL_BOOKING,
  CLEAR_ERROR,
  REMOVE_BOOKING,
  SEARCH_BOOK_AMENITIES,
  SEARCH_BOOK_BY_TYPE,
  SEARCH_BOOK_BY_DATE_RANGE,
  SEARCH_BOOK_PARKINGS,
  SEARCH_BOOK_ELEVATOR,
  BOOKING_FROM_AMENITY,
  GET_ELEVATOR_PAR_AM_BOOKINGS,
  RESET_BOOKING_PAGINATION,
  CLEAR_PAR_AM_BOOKING,
  SET_BOOKING_SEARCH,
  SET_LAST_BOOKINGS_CALENDAR_V3_PARAMS
} from '../constants';
import { requestSuccess, requestFail, requestPending } from '../../utils/status';

const initialData = {
  selectedbookings: [],
  weeklybookings: [],
  parkingbookings: [],
  amenitybookings: [],
  elevatorbookings: [],
  allBookings: [],
  booking: {},
  search: {
    amenityIds: [],
    statusIds: [],
    query: '',
    search_col: '',
    startDate: null,
    endDate: null,
    showBlocks: false
  },
  availableTime: [],
  availabilitySlotsV2: [],
  bookingCostBreakdown: null,
  editBooking: false,
  status: '',
  error: '',
  isBookingFromAmenity: false,
  pagination: {
    currentPage: 1,
    perPage: null,
    total: null,
    totalPages: null
  },
  lastBookingsCalendarV3Params: null
};

export default createReducer(initialData, {
  [CLEAR_ERROR]: (state) => ({
    ...state,
    error: null
  }),

  [CLEAR_AMENITY_AVAILABILITY_V2]: (state) => ({
    ...state,
    availabilitySlotsV2: []
  }),

  [CLEAR_BOOKING_COST_BREAKDOWN]: (state) => ({
    ...state,
    bookingCostBreakdown: null
  }),

  [BOOKING_FROM_AMENITY]: (state, { payload }) => ({
    ...state,
    isBookingFromAmenity: payload
  }),
  [RESET_BOOKING_PAGINATION]: (state, {}) => ({
    ...state,
    pagination: {
      currentPage: 1,
      perPage: null,
      total: null,
      totalPages: null
    }
  }),

  [SET_BOOKING_SEARCH]: (state, { payload }) => {
    return {
      ...state,
      search: {
        ...state.search,
        ...payload
      }
    };
  },

  [SET_LAST_BOOKINGS_CALENDAR_V3_PARAMS]: (state, { payload }) => ({
    ...state,
    lastBookingsCalendarV3Params: payload ?? null
  }),

  [requestSuccess(SEARCH_BOOK_AMENITIES)]: (state, { payload }) => ({
    ...state,
    amenitybookings: payload.data,
    status: requestSuccess(SEARCH_BOOK_AMENITIES),
    booking: {},
    availableTime: [],
    error: null
  }),

  [requestPending(SEARCH_BOOK_AMENITIES)]: (state, { payload }) => ({
    ...state,
    status: requestPending(SEARCH_BOOK_AMENITIES)
  }),

  [requestSuccess(SEARCH_BOOK_BY_TYPE)]: (state, { payload }) => {
    return {
      ...state,
      selectedbookings: payload.data,
      status: requestSuccess(SEARCH_BOOK_BY_TYPE),
      booking: {},
      availableTime: [],

      pagination: {
        currentPage: payload.current_page,
        perPage: payload.per_page,
        total: payload.total
      },

      error: null
    };
  },
  [requestPending(SEARCH_BOOK_BY_TYPE)]: (state, { payload }) => ({
    ...state,
    status: requestPending(SEARCH_BOOK_BY_TYPE)
  }),

  [requestSuccess(SEARCH_BOOK_BY_DATE_RANGE)]: (state, { payload }) => {
    return {
      ...state,
      weeklybookings: payload.data,
      status: requestSuccess(SEARCH_BOOK_BY_DATE_RANGE),
      booking: {},
      availableTime: [],
      error: null
    };
  },
  [requestFail(SEARCH_BOOK_BY_DATE_RANGE)]: (state, { payload }) => ({
    ...state,
    weeklybookings: [],
    status: requestFail(SEARCH_BOOK_BY_DATE_RANGE),
    error: payload?.data?.message
  }),
  [requestPending(SEARCH_BOOK_BY_DATE_RANGE)]: (state, { payload }) => ({
    ...state,
    status: requestPending(SEARCH_BOOK_BY_DATE_RANGE)
  }),

  [requestFail(SEARCH_BOOK_AMENITIES)]: (state, { payload }) => ({
    ...state,
    amenitybookings: [],
    status: requestFail(SEARCH_BOOK_AMENITIES),
    error: payload?.data?.message
  }),

  [requestSuccess(SEARCH_BOOK_ELEVATOR)]: (state, { payload }) => ({
    ...state,
    elevatorbookings: payload.data,
    status: requestSuccess(SEARCH_BOOK_ELEVATOR),
    booking: {},
    availableTime: [],
    error: null
  }),

  [requestPending(SEARCH_BOOK_ELEVATOR)]: (state, { payload }) => ({
    ...state,
    status: requestPending(SEARCH_BOOK_ELEVATOR)
  }),

  [requestFail(SEARCH_BOOK_ELEVATOR)]: (state, { payload }) => ({
    ...state,
    amenitybookings: [],
    status: requestFail(SEARCH_BOOK_ELEVATOR),
    error: payload?.data?.message
  }),

  [requestSuccess(SEARCH_BOOK_PARKINGS)]: (state, { payload }) => ({
    ...state,
    parkingbookings: payload.data,
    status: requestSuccess(SEARCH_BOOK_PARKINGS),
    booking: {},
    availableTime: [],
    error: null
  }),

  [requestPending(SEARCH_BOOK_PARKINGS)]: (state, { payload }) => ({
    ...state,
    status: requestPending(SEARCH_BOOK_PARKINGS)
  }),

  [requestFail(SEARCH_BOOK_PARKINGS)]: (state, { payload }) => ({
    ...state,
    parkingbookings: [],
    status: requestFail(SEARCH_BOOK_PARKINGS),
    error: payload?.data?.message
  }),

  [requestSuccess(REMOVE_BOOKING)]: (state, { payload }) => ({
    ...state,
    status: requestSuccess(REMOVE_BOOKING),
    error: null
  }),

  [requestPending(REMOVE_BOOKING)]: (state, { payload }) => ({
    ...state,
    status: requestPending(REMOVE_BOOKING)
  }),

  [requestFail(REMOVE_BOOKING)]: (state, { payload }) => ({
    ...state,
    status: requestFail(REMOVE_BOOKING),
    error: payload.data.message
  }),

  [requestSuccess(GET_AMENITY_PAR_AM_BOOKINGS)]: (state, { payload }) => {
    return {
      ...state,
      amenitybookings: payload,
      status: requestSuccess(GET_AMENITY_PAR_AM_BOOKINGS),
      booking: {},
      availableTime: [],
      error: null
    };
  },
  [requestPending(GET_AMENITY_PAR_AM_BOOKINGS)]: (state, { payload }) => ({
    ...state,
    status: requestPending(GET_AMENITY_PAR_AM_BOOKINGS)
  }),

  [requestFail(GET_AMENITY_PAR_AM_BOOKINGS)]: (state, { payload }) => ({
    ...state,
    amenitybookings: [],
    status: requestFail(GET_AMENITY_PAR_AM_BOOKINGS),
    booking: {},
    availableTime: [],
    error: payload?.data?.message
  }),

  [requestSuccess(GET_ELEVATOR_PAR_AM_BOOKINGS)]: (state, { payload }) => ({
    ...state,
    elevatorbookings: payload,
    status: requestSuccess(GET_ELEVATOR_PAR_AM_BOOKINGS),
    booking: {},
    availableTime: [],
    error: null
  }),

  [requestPending(GET_ELEVATOR_PAR_AM_BOOKINGS)]: (state, { payload }) => ({
    ...state,
    status: requestPending(GET_ELEVATOR_PAR_AM_BOOKINGS)
  }),

  [requestFail(GET_ELEVATOR_PAR_AM_BOOKINGS)]: (state, { payload }) => ({
    ...state,
    elevatorbookings: [],
    status: requestFail(GET_ELEVATOR_PAR_AM_BOOKINGS),
    booking: {},
    availableTime: [],
    error: payload?.data?.message
  }),

  [requestSuccess(GET_PARKING_PAR_AM_BOOKINGS)]: (state, { payload }) => ({
    ...state,
    parkingbookings: payload,
    status: requestSuccess(GET_PARKING_PAR_AM_BOOKINGS),
    booking: {},
    availableTime: [],
    error: null
  }),

  [requestPending(GET_PARKING_PAR_AM_BOOKINGS)]: (state, { payload }) => ({
    ...state,
    status: requestPending(GET_PARKING_PAR_AM_BOOKINGS)
  }),

  [requestSuccess(GET_SELECTED_BOOKINGS)]: (state, { payload }) => ({
    ...state,
    selectedbookings: payload?.data,
    pagination: {
      currentPage: payload?.pagination['pagination-current-page'],
      perPage: payload?.pagination['pagination-per-page'],
      total: payload?.pagination['pagination-total']
    },
    status: requestSuccess(GET_SELECTED_BOOKINGS),
    booking: {},
    availableTime: [],
    error: null
  }),

  [requestPending(GET_SELECTED_BOOKINGS)]: (state, { payload }) => ({
    ...state,
    status: requestPending(GET_SELECTED_BOOKINGS)
  }),

  [requestSuccess(GET_BOOKINGS_LIST_V3)]: (state, { payload }) => ({
    ...state,
    selectedbookings: payload?.data,
    pagination: {
      currentPage: payload?.pagination['pagination-current-page'],
      perPage: payload?.pagination['pagination-per-page'],
      total: payload?.pagination['pagination-total']
    },
    status: requestSuccess(GET_BOOKINGS_LIST_V3),
    booking: {},
    availableTime: [],
    error: null
  }),

  [requestPending(GET_BOOKINGS_LIST_V3)]: (state, { payload }) => ({
    ...state,
    status: requestPending(GET_BOOKINGS_LIST_V3)
  }),

  [requestFail(GET_BOOKINGS_LIST_V3)]: (state, { payload }) => ({
    ...state,
    status: requestFail(GET_BOOKINGS_LIST_V3),
    error: payload?.data?.message
  }),

  [requestSuccess(GET_BOOKINGS_CALENDAR_V3)]: (state, { payload }) => ({
    ...state,
    weeklybookings: Array.isArray(payload) ? payload : (payload?.data ?? []),
    status: requestSuccess(GET_BOOKINGS_CALENDAR_V3),
    booking: {},
    availableTime: [],
    error: null
  }),

  [requestPending(GET_BOOKINGS_CALENDAR_V3)]: (state) => ({
    ...state,
    status: requestPending(GET_BOOKINGS_CALENDAR_V3)
  }),

  [requestFail(GET_BOOKINGS_CALENDAR_V3)]: (state, { payload }) => ({
    ...state,
    weeklybookings: [],
    status: requestFail(GET_BOOKINGS_CALENDAR_V3),
    error: payload?.data?.message
  }),

  [requestFail(GET_PARKING_PAR_AM_BOOKINGS)]: (state, { payload }) => ({
    ...state,
    parkingbookings: [],
    status: requestFail(GET_PARKING_PAR_AM_BOOKINGS),
    booking: {},
    availableTime: [],
    error: payload?.data?.message
  }),

  [requestSuccess(EDIT_PAR_AM_BOOKING)]: (state, { payload }) => ({
    ...state,
    status: requestSuccess(EDIT_PAR_AM_BOOKING),
    error: ''
  }),

  [requestPending(EDIT_PAR_AM_BOOKING)]: (state, { payload }) => ({
    ...state,
    status: requestPending(EDIT_PAR_AM_BOOKING)
  }),

  [requestFail(EDIT_PAR_AM_BOOKING)]: (state, { payload }) => ({
    ...state,
    status: requestFail(EDIT_PAR_AM_BOOKING),
    error: payload.data.message
  }),

  [requestSuccess(ADD_PAR_AM_BOOKING)]: (state, { payload }) => ({
    ...state,
    status: requestSuccess(ADD_PAR_AM_BOOKING),
    error: ''
  }),

  [requestPending(ADD_PAR_AM_BOOKING)]: (state, { payload }) => ({
    ...state,
    status: requestPending(ADD_PAR_AM_BOOKING)
  }),

  [requestFail(ADD_PAR_AM_BOOKING)]: (state, { payload }) => ({
    ...state,
    status: requestFail(ADD_PAR_AM_BOOKING),
    error: payload?.data?.message
  }),

  [requestSuccess(ADD_BOOKING_V3)]: (state, { payload }) => ({
    ...state,
    status: requestSuccess(ADD_BOOKING_V3),
    error: ''
  }),

  [requestPending(ADD_BOOKING_V3)]: (state, { payload }) => ({
    ...state,
    status: requestPending(ADD_BOOKING_V3)
  }),

  [requestFail(ADD_BOOKING_V3)]: (state, { payload }) => ({
    ...state,
    status: requestFail(ADD_BOOKING_V3),
    error: payload?.data?.message
  }),

  [requestSuccess(EDIT_BOOKING_V3)]: (state, { payload }) => ({
    ...state,
    booking: payload,
    status: requestSuccess(EDIT_BOOKING_V3),
    error: null
  }),

  [requestPending(EDIT_BOOKING_V3)]: (state) => ({
    ...state,
    status: requestPending(EDIT_BOOKING_V3)
  }),

  [requestFail(EDIT_BOOKING_V3)]: (state, { payload }) => ({
    ...state,
    status: requestFail(EDIT_BOOKING_V3),
    error: payload?.data?.message
  }),

  [requestSuccess(GET_AMENITY_AVAILABILITY_V2)]: (state, { payload }) => ({
    ...state,
    availabilitySlotsV2: Array.isArray(payload) ? payload : [],
    status: requestSuccess(GET_AMENITY_AVAILABILITY_V2),
    error: null
  }),

  [requestPending(GET_AMENITY_AVAILABILITY_V2)]: (state) => ({
    ...state,
    availabilitySlotsV2: [],
    status: requestPending(GET_AMENITY_AVAILABILITY_V2)
  }),

  [requestFail(GET_AMENITY_AVAILABILITY_V2)]: (state) => ({
    ...state,
    availabilitySlotsV2: [],
    status: requestFail(GET_AMENITY_AVAILABILITY_V2)
  }),

  [requestSuccess(GET_BOOKING_COST_BREAKDOWN)]: (state, { payload }) => {
    const breakdown =
      payload?.cost != null
        ? payload
        : payload?.data?.cost != null
          ? payload.data
          : payload?.data ?? null;
    return {
      ...state,
      bookingCostBreakdown: breakdown,
      status: requestSuccess(GET_BOOKING_COST_BREAKDOWN),
      error: null
    };
  },

  [requestPending(GET_BOOKING_COST_BREAKDOWN)]: (state) => ({
    ...state,
    bookingCostBreakdown: null,
    status: requestPending(GET_BOOKING_COST_BREAKDOWN)
  }),

  [requestFail(GET_BOOKING_COST_BREAKDOWN)]: (state, { payload }) => ({
    ...state,
    bookingCostBreakdown: null,
    status: requestFail(GET_BOOKING_COST_BREAKDOWN),
    error: payload?.data?.message
  }),

  [requestSuccess(GET_AVAILABLE_TIME)]: (state, { payload }) => ({
    ...state,
    availableTime: payload,
    status: requestSuccess(GET_AVAILABLE_TIME),
    error: null
  }),

  [requestPending(GET_AVAILABLE_TIME)]: (state, { payload }) => ({
    ...state,
    status: requestPending(GET_AVAILABLE_TIME)
  }),

  [requestFail(GET_AVAILABLE_TIME)]: (state, { payload }) => ({
    ...state,
    status: requestFail(GET_AVAILABLE_TIME),
    error: payload.data.message
  }),

  [requestSuccess(CANCEL_BOOKING)]: (state, { payload }) => ({
    ...state,
    availableTime: [],
    status: requestSuccess(CANCEL_BOOKING),
    error: null
  }),

  [requestPending(CANCEL_BOOKING)]: (state, { payload }) => ({
    ...state,
    status: requestPending(CANCEL_BOOKING)
  }),

  [requestFail(CANCEL_BOOKING)]: (state, { payload }) => ({
    ...state,
    status: requestFail(CANCEL_BOOKING),
    error: payload.data.message
  }),

  [requestSuccess(GET_PAR_AM_BOOKING)]: (state, { payload }) => ({
    ...state,
    booking: payload,
    status: requestSuccess(GET_PAR_AM_BOOKING)
  }),
  [requestPending(GET_PAR_AM_BOOKING)]: (state, { payload }) => ({
    ...state,
    status: requestPending(GET_PAR_AM_BOOKING)
  }),
  [requestFail(GET_PAR_AM_BOOKING)]: (state, { payload }) => ({
    ...state,
    error: payload.data?.message,
    status: requestFail(GET_PAR_AM_BOOKING)
  }),

  [requestSuccess(GET_BOOKING_V3)]: (state, { payload }) => ({
    ...state,
    booking: payload,
    status: requestSuccess(GET_BOOKING_V3),
    error: null
  }),
  [requestPending(GET_BOOKING_V3)]: (state) => ({
    ...state,
    status: requestPending(GET_BOOKING_V3)
  }),
  [requestFail(GET_BOOKING_V3)]: (state, { payload }) => ({
    ...state,
    error: payload.data?.message,
    status: requestFail(GET_BOOKING_V3)
  }),
  [SET_PARAM_ERROR]: (state, { payload }) => ({
    ...state,
    error: ''
  }),
  [EDITING_PAR_AM_BOOKING]: (state, { payload }) => ({
    ...state,
    editBooking: payload.editBooking
  }),
  [CLEAR_PAR_AM_BOOKING]: (state) => ({
    ...state,
    selectedbookings: []
  })
});
